var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMothericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002259"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1885",
    cx: 10,
    cy: 10,
    r: 9.75,
    stroke: "#DA7B0C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1886",
    cx: 5,
    cy: 10,
    r: 1.5,
    stroke: "#FF9212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1887",
    cx: 10,
    cy: 10,
    r: 1.5,
    stroke: "#FF9212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1888",
    cx: 15,
    cy: 10,
    r: 1.5,
    stroke: "#FF9212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMothericon);
export default __webpack_public_path__ + "static/media/mothericon.23d34eb73550249538183dc5e8d13aa6.svg";
export { ForwardRef as ReactComponent };